import {yupResolver} from '@hookform/resolvers/yup'
import {enqueueSnackbar} from 'notistack'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {Controller, useForm} from 'react-hook-form'
import Select from 'react-select'
import * as Yup from 'yup'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {FurnitureModel} from '../../../furniture/models'
import {editFurnitureService} from '../../../furniture/services/editFurniture.service'
import {getFurnitureByIdService} from '../../../furniture/services/getFurnitureById.service'
import {MasterModel, ModuleModel} from '../../../modules/models'
import {getMasterModuleService, getModulesService} from '../../../modules/services'
import {getSnackBarToast} from '../../../../../../util/snackBar'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  furnitureToEdit: FurnitureModel
  getFurnitures: () => void
}

const ModalUpdateFurniture: FC<Props> = ({show, setShow, furnitureToEdit, getFurnitures}) => {
  const handleClose = () => {
    setShow(false)
  }
  const [, setModules] = useState<ModuleModel[] | any>([])
  const [furnitureTypes, setFurnitureTypes] = useState<MasterModel[] | any>([])
  const {currentTabItem} = useHoteleria()

  const newFurnitureSchema = Yup.object().shape({
    ModuloId: Yup.string().required('Módulo es requerido'),
    HabitacionId: Yup.string().required('Habitación es requerido'),
    TipoMobiliarioId: Yup.string().required('Tipo de Mobiliario es requerido'),
    Codigo: Yup.string().required('Código es requerido'),
    Descripcion: Yup.string().required('Descripción es requerido'),
    Observaciones: Yup.string().required('Observaciones es requerido'),
  })

  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  useEffect(() => {
    getModules()
    getFurnitureTypes()
  }, [])

  const {
    register,
    setValue,
    handleSubmit,
    // watch,
    control,
    formState: {errors},
  } = useForm<FurnitureModel>({
    resolver: yupResolver(newFurnitureSchema),
  })

  const getModules = async () => {
    try {
      const {data: response} = await getModulesService({
        pageNumber: 1,
        size: 1000,
      })
      const mappedModules = response.data?.map((item) => ({value: item.Id, label: item.Codigo}))
      setModules(mappedModules)
    } catch (error) {
      setModules([])
    }
  }

  const getFurnitureTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoMobiliario',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setFurnitureTypes(mappedMaster)
    } catch (error) {
      setFurnitureTypes([])
    }
  }

  useEffect(() => {
    if (show) {
      getFurnitureData()
    }
  }, [show])

  const getFurnitureData = async () => {
    try {
      const {
        data: {data},
      } = await getFurnitureByIdService(furnitureToEdit.Id)
      const {Codigo, ModuloId, Observaciones, Descripcion, TipoMobiliarioId} = data
      setValue('Id', furnitureToEdit.Id)
      setValue('HabitacionId', currentTabItem.idToEdit as any)
      setValue('ModuloId', ModuloId)
      setValue('TipoMobiliarioId', TipoMobiliarioId)
      setValue('Codigo', Codigo)
      setValue('Observaciones', Observaciones)
      setValue('Descripcion', Descripcion)
    } catch (error) {}
  }

  const onSubmit = async (data: FurnitureModel) => {
    try {
      const {data: res} = await editFurnitureService(data)
      if (!res.error) {
        getSnackBarToast('Se actualizó con exito', 'success')

        handleClose()
        getFurnitures()
        //mostrar snackbar
      } else {
        getSnackBarToast(res.message, 'error')
      }
    } catch (error) {}
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Editar Mobiliario</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='p-6'>
              <div className='d-flex'>
                <div className='col-6'>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Tipo de Mobiliario</label>
                    <div className='input-group input-group-sm'>
                      <Controller
                        control={control}
                        name='TipoMobiliarioId'
                        render={({field}) => (
                          <Select
                            {...field}
                            className='w-100'
                            options={furnitureTypes}
                            placeholder='Selecciona un Tipo de Mobiliario'
                            value={furnitureTypes?.find(
                              (c: {value: string}) => c.value === field.value,
                            )}
                            onChange={(val) => field.onChange(val ? val.value : '')}
                          />
                        )}
                      />
                      <p
                        style={{
                          marginBottom: '0',
                          fontSize: '10px',
                          fontWeight: '600',
                          color: 'red',
                          marginLeft: '5px',
                        }}
                      >
                        {errors.TipoMobiliarioId?.message}
                      </p>
                    </div>
                  </div>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Código de mobiliario</label>
                    <div className='input-group input-group-sm'>
                      <input type='text' className='form-control' {...register('Codigo')} />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Codigo?.message}
                    </p>
                  </div>
                </div>
                <div className='col-6'>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Descripción de Mobiliario</label>
                    <div className='input-group input-group-sm'>
                      <input type='text' className='form-control' {...register('Descripcion')} />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Descripcion?.message}
                    </p>
                  </div>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Observaciones</label>
                    <div className='input-group input-group-sm'>
                      <input type='text' className='form-control' {...register('Observaciones')} />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Observaciones?.message}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalUpdateFurniture}
